import { get } from 'lodash';

import { Tag, isDefined } from 'common';
import { LlmModelLifecycleState } from 'llm-model-registry';

import { MODEL_NAME_CONFIG_PATHS, useModelLifecycleResult } from '../../../../lib/LlmModels';
import { type ReactFlowBlockNodeProps } from '../types';

interface DeprecatedModelDecoratorProps {
  data: ReactFlowBlockNodeProps['data'];
}

export function DeprecatedModelDecorator(props: DeprecatedModelDecoratorProps) {
  const { data } = props;
  const configPath = MODEL_NAME_CONFIG_PATHS[data.uiBlockType];
  const modelName = isDefined(configPath)
    ? (get(data, configPath) as string | undefined)
    : undefined;
  const { data: lifecycleData } = useModelLifecycleResult();
  const lifecycleEntry = isDefined(modelName) ? lifecycleData?.models[modelName] : undefined;

  if (!isDefined(lifecycleEntry)) {
    return null;
  }

  if (lifecycleEntry.lifecycleState === LlmModelLifecycleState.Obsolete) {
    return (
      <Tag color="error" sx={{ alignSelf: 'start' }}>
        Model obsolete {lifecycleEntry.obsoleteDate}
      </Tag>
    );
  }

  if (lifecycleEntry.lifecycleState === LlmModelLifecycleState.Retired) {
    return (
      <Tag color="warning" sx={{ alignSelf: 'start' }}>
        Model retired {lifecycleEntry.retiredDate}
      </Tag>
    );
  }

  return null;
}
